<template>
  <v-app id="inspire">
    <loader :show="enviando"/>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Iniciar sesión</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field 
                    prepend-icon="person" 
                    name="login" 
                    label="Código" 
                    type="text"
                    v-model="codigo" 
                    required
                    :disabled="enviando"
                    >
                  </v-text-field>
                  <v-text-field 
                    id="password" 
                    prepend-icon="lock" 
                    name="password" 
                    label="Contraseña" 
                    type="password"
                    v-model="password" 
                    required
                    :disabled="enviando"
                    >
                  </v-text-field>
                  <p class="errorMessage">{{errorMessage}}</p>
                  <v-checkbox 
                    color="primary" 
                    label="Mantener sesión iniciada" 
                    v-model="checkbox"
                    :disabled="enviando"
                  ></v-checkbox>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"
                  @click="submit()" 
                  block 
                  :disabled="enviando"
                >Iniciar sesión</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters} from 'vuex'
import axios from 'axios'
import Loader from '../components/Loader'

export default {
  components:{
    Loader
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken"
    ])
  },
  data() {
      return {
        enviando: false,
        checkbox: false,
        codigo:'',
        password: "",
        enviando: false,
        errorMessage: ''
      }
  },
  created(){
    if( sessionStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
    if( localStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", localStorage.getItem("token"));
    
    if( this.sessionToken ){
      axios.get(this.httpURL+'/login',{headers:{token: this.sessionToken}})
          .then(res => {
            this.$router.push('/inicio');  
          })
          .catch(error => {
            this.submitStatus = '';
            this.errorMessage = error.response.data.mensaje;
            this.mensaje = '';
            this.enviando = false;
        });
    }
  },
  methods:{
    submit() {
      if( !this.codigo || !this.password )
        this.errorMessage = 'Debe llenar todos los campos';
      else{
        this.enviando = true;
        axios.post(this.httpURL+'/login',{
              codigo: this.codigo,
              password: this.password
          })
          .then(res => {
              // console.log(res);
              if( res.data.ok ){
                let token = res.data.token;
                this.mensaje = 'Autenticado correctamente';
                this.checkbox ? localStorage.setItem("sessionToken",sessionToken) : sessionStorage.setItem("token",token);
                this.enviando = false;
                this.$store.dispatch("setSessionToken", token);
                this.$router.push('/inicio');
              }else{
                this.submitStatus = '';
                this.errorMessage = res.data.mensaje;
                this.mensaje = '';
                this.enviando = false;
              }
          })
          .catch(error => {
              this.submitStatus = '';
              this.errorMessage = error.response.data.mensaje;
              this.mensaje = '';
              this.enviando = false;
          });
      }
    }
  }
}
</script>

<style>
.errorMessage {
    color: #FF0000
}
.invalid_input{
    border: 1px solid red;
}
</style>